module.exports = __webpack_public_path__ + "static/media/Q9-3.20f9b2db.jpg";